export default "__VITE_ASSET__874d1f3b__"